import { getRentalBatteriesRequest } from '../../services/equipment';
import { RENTAL_BATTERIES_CACHE_KEY } from '../../services/queryKeys';
import { useAxiosQuery } from '../useAxiosQuery';
import { Equipment, EquipmentHookReturn } from './types';

/**
 * Hook to fetch rental batteries from Greener Power Solution catalog
 * This endpoint returns batteries available for rental from the main organization
 * Used when user is from a different organization and needs to see Greener's battery catalog
 */
export function useGetRentalBatteries(): EquipmentHookReturn {
  const {
    data: equipment,
    isLoading,
    error,
    refetch,
  } = useAxiosQuery<Equipment[]>(RENTAL_BATTERIES_CACHE_KEY, getRentalBatteriesRequest().path, {
    enabled: true,
  });

  return {
    equipment: equipment || [],
    isLoading,
    error: error ? String(error) : null,
    refetch,
  };
}

